// libs
import React from 'react';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// components
import { GenericAvatar } from '@/widgets/GenericAvatar';
// styles
import styles from './AccountsList.module.scss';
// NOTE: Keeping for M2
// const avatarSize = 64;
// const CREATE_ACCOUNT = {
//     buttonText: "Add New Account",
//     iconColor: "#F15700",
//     iconSize: 28,
//     key: "create-new-account"
// }
const AccountList = ({ accounts, onAccountClick }) => {
    return (React.createElement("div", { className: styles.container },
        React.createElement("ul", { className: styles.accountList }, accounts.map((account) => (React.createElement("li", { key: account.accountId || account.name, onClick: () => onAccountClick(account), className: styles.account, tabIndex: 0 },
            React.createElement(GenericAvatar, { className: styles.accountAvatar, name: account.name }),
            React.createElement("div", { className: styles.accountDetails },
                React.createElement(Text, { variant: DlsFontVariants.header_H5_Bold, color: DlsColorTokens.text_Highest_Emphasis, className: styles.accountName }, account.name))))))));
};
export default AccountList;
